import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";
import { CheckCircle, ArrowRight } from "lucide-react";
import { mockLoanPrograms } from "../data/mockData";

const LoanPrograms = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#0b2c4a] to-[#1a4b73] text-white py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Loan Programs for Every Need
            </h1>
            <p className="text-xl text-blue-100 mb-8">
              From first-time homebuyers to seasoned investors, we have the right loan program 
              to help you achieve your homeownership goals.
            </p>
            <Button 
              size="lg" 
              className="bg-white text-[#0b2c4a] hover:bg-gray-100"
              asChild
            >
              <Link to="/calculators">Calculate Your Payment</Link>
            </Button>
          </div>
        </div>
      </section>

      {/* Loan Programs Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {mockLoanPrograms.map((program) => (
              <Card key={program.id} className="hover:shadow-lg transition-shadow duration-200 border-none bg-white">
                <CardHeader className="pb-4">
                  <div className="flex items-center justify-between mb-2">
                    <Badge 
                      variant="secondary" 
                      className="bg-[#0b2c4a]/10 text-[#0b2c4a] hover:bg-[#0b2c4a]/20"
                    >
                      {program.name}
                    </Badge>
                  </div>
                  <CardTitle className="text-xl text-gray-900">
                    {program.name}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 mb-6 text-sm leading-relaxed">
                    {program.description}
                  </p>
                  <div className="space-y-3 mb-6">
                    {program.features.map((feature, index) => (
                      <div key={index} className="flex items-start space-x-2">
                        <CheckCircle className="h-4 w-4 text-[#0b2c4a] mt-0.5 flex-shrink-0" />
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <Button 
                    className="w-full bg-[#0b2c4a] hover:bg-[#0b2c4a]/90 text-white"
                    asChild
                  >
                    <Link to="/team" className="flex items-center justify-center">
                      Learn More
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Link>
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Not Sure Which Program is Right for You?
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            Our experienced loan advisors will help you find the perfect loan program 
            based on your unique situation and goals.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              className="bg-[#0b2c4a] hover:bg-[#0b2c4a]/90 text-white"
              asChild
            >
              <Link to="/team">Speak with an Advisor</Link>
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-[#0b2c4a] text-[#0b2c4a] hover:bg-[#0b2c4a] hover:text-white"
              asChild
            >
              <Link to="/calculators">Use Our Calculators</Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LoanPrograms;